(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-product-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const XF_ID = 'xf-sticky-card';

    const card = document.getElementById(XF_ID);
    if (!card) return;

    const mainContent = document.getElementById('MainContent');
    const displayMode = card.getAttribute('data-display-mode');
    const threshold = parseInt(card.getAttribute('data-threshold'), 10) || 300;
    let chatNudge = null;
    let isVisible = false;

    function xfEnsureChatNudge() {
      if (chatNudge) return true;
      const shopifyChat = document.querySelector('shopify-chat');
      if (!(shopifyChat && shopifyChat.shadowRoot)) return false;
      chatNudge = shopifyChat.shadowRoot.querySelector('.activator-nudge');
      return !!chatNudge;
    }

    function xfIsMainContentBottomInView() {
      if (!mainContent) return false;
      const rect = mainContent.getBoundingClientRect();
      return rect.bottom <= window.innerHeight;
    }

    function xfUpdateChatNudge(show) {
      if (!xfEnsureChatNudge()) return;
      chatNudge.style.marginBottom = show ? '80px' : '';
    }

    let ticking = false;

    function xfOnScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          let shouldShow;

          if (displayMode === 'always') {
            shouldShow = !xfIsMainContentBottomInView();
          } else {
            shouldShow = window.scrollY > threshold && !xfIsMainContentBottomInView();
          }

          if (shouldShow !== isVisible) {
            isVisible = shouldShow;
            card.classList.toggle('is-visible', isVisible);
          }

          xfUpdateChatNudge(isVisible);
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', xfOnScroll, { passive: true });
    xfOnScroll();
  })();

  } catch(e) { console.error(e); }
})();
})();
